import React, { useState, useEffect } from "react";
import styled from "styled-components";
import languageList from '../assets/language/language.json';
import { useSearchParams, useParams } from "react-router-dom";

const SearchContainer = styled.div`
  position: relative;
  margin: 20px 28px;
  width: ${props => props.width || '300px'};
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 17px 40px 5px 10px;
  color: #000000de;
  font-weight: 400;
  letter-spacing: .00937em;
  border: 1.5px solid #0000003d;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s ease;
  box-sizing: border-box;

  &:focus {
    border-color: #192d6e;
  }

  &:focus ~ label {
    top: 10px;
    left: 10px;
    font-size: 12px;
    color: #192d6e;
  }
  &:not(:placeholder-shown) ~ label {
    top: 10px;
    left: 10px;
    font-size: 12px;
  }
`;

const FloatingLabel = styled.label`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #0009;
  background: white;
  padding: 0;
  transition: all 0.3s ease;
  pointer-events: none;
`;

const SearchIcon = styled.img`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  height: 20px;
  opacity: .9;
`;

const SearchBar = ({onSendData, query, width}) => {
  const [languages, setLanguage] = useState(null);
  const [searchParams] = useSearchParams();
  const language = searchParams.get("lang") || 'en';

  useEffect(() => {
    if(languageList[language]){
      setLanguage(languageList[language])
    } else {
      setLanguage(languageList['en'])
    }

  }, [language])

  return (
    <SearchContainer width={width}>
      <SearchInput
        type="text"
        value={query}
        onChange={(e) => onSendData(e.target.value)}
        placeholder=" "
      />
      <FloatingLabel>{languages?.search}</FloatingLabel>
      <SearchIcon src={'/images/search-icon.svg'}/>
    </SearchContainer>
  );
};

export default SearchBar;
